import {Action} from "redux-actions";
import {JOB_TAGS_FETCHED, TAGS_FETCHED} from "./actionType";
import {OnFailure, OnSuccess} from "../actionHelpers";
import {Dispatch} from "redux";
import {api} from "../../../api/api";
import Tag from "../../../model/tag/Tag";

/**
 * Tags fetched successful action.
 * @param {tags} tags all tags.
 * @return {Action<TAGS_FETCHED>}
 */
function tagsFetched(tags: Tag[]): Action<TAGS_FETCHED> {
	return {type: TAGS_FETCHED, payload: {tags}}
}

/**
 * Tags fetched successful action.
 * @param {tags} tags all tags.
 * @return {Action<TAGS_FETCHED>}
 */
function jobTagsFetched(tags: Tag[]): Action<JOB_TAGS_FETCHED> {
	return {type: JOB_TAGS_FETCHED, payload: {tags}}
}

/**
 * Fetch tags.
 * @param {OnSuccess} onSuccess
 * @param {OnFailure} onFailure
 */
export function fetchTags(onSuccess: OnSuccess, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.tagApi.fetchTags().then(tags => {
			dispatch(tagsFetched(tags));
			onSuccess();
		})
	}
}

/**
 * Fetch tags.
 * @param {OnSuccess} onSuccess
 * @param {OnFailure} onFailure
 */
export function fetchJobTags(onSuccess: OnSuccess, onFailure: OnFailure) {
	return function(dispatch: Dispatch<any>) {
		api.instance.tagApi.fetchJobTags().then(tags => {
			dispatch(jobTagsFetched(tags));
			onSuccess();
		})
	}
}
